// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  onMessage,
} from 'firebase/messaging';
import { userApi } from './api/administration/user-api';
import { setItem } from './utils/localStorage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getPerformance } from 'firebase/performance';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBr9j0qhgNMJvrAqlKeYpuPbe1yaHMfmfk',
  authDomain: 'mobifone-ework.firebaseapp.com',
  projectId: 'mobifone-ework',
  storageBucket: 'mobifone-ework.appspot.com',
  messagingSenderId: '583066334849',
  appId: '1:583066334849:web:ef78c011971e3c85053f80',
  measurementId: 'G-EW9FLEEZVN',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firebasePerfTracker = await getPerformance(app);

const messaging = getMessaging(app);

export const fetchToken = (setTokenFound: any) => {
  return getToken(messaging, {
    vapidKey:
      'BBhhy9gNg0uCqXNTvLXhsDvZSqRoK-3fZefgcZVQqk1_fpjRaQa_dLt5AG0uMdTGe5aVTJ5blOQ2c_SwRpb6NAI',
  })
    .then(currentToken => {
      if (currentToken) {
        console.log(
          'current token for client: ',
          currentToken,
        );
        userApi.saveNotificationToken({
          token: currentToken,
        });
        setItem('ework_firebase_token', currentToken);
        setTokenFound(true);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          'No registration token available. Request permission to generate one.',
        );
        setTokenFound(false);
        // shows on the UI that permission is required
      }
    })
    .catch(err => {
      console.log(
        'An error occurred while retrieving token. ',
        err,
      );
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise(resolve => {
    onMessage(messaging, payload => {
      resolve(payload);
    });
  });
